import moment from 'moment';
import { TELEMETRY_TIME_FORMAT } from '../../../../../../common/constants/telemetry';
import { getOffsetByFormatType, TimeFormatType } from '../../../../../../common/components/TimeFormat/TimeFormat';

const defaultFilterValues = {
  // main
  metrics: [''],
  utc: getOffsetByFormatType(TimeFormatType.UTC),
  // history
  from: moment().utc().subtract(7, 'days').format(TELEMETRY_TIME_FORMAT),
  to: moment().utc().format(TELEMETRY_TIME_FORMAT),
  // real time
  timeRange: 1,
};

const demoFilterValues = {
  // main
  metrics: [''],
  utc: getOffsetByFormatType(TimeFormatType.UTC),
  // history
  from: moment().utc().subtract(1, 'day').startOf('day')
    .format(TELEMETRY_TIME_FORMAT),
  to: moment().utc().endOf('day').format(TELEMETRY_TIME_FORMAT),
  // real time
  timeRange: 3,
};

export {
  defaultFilterValues, demoFilterValues,
};
